import React from 'react';
import { StyleBa } from './StyleBnner';
import BannerForm from '../bannerForm/BannerForm';

const Banner = () => {
    return (
        <StyleBa>
            <BannerForm />
        </StyleBa>
    )
}

export default Banner